import { render, staticRenderFns } from "./data-service3.vue?vue&type=template&id=019dad30&scoped=true"
import script from "./data-service3.vue?vue&type=script&lang=js"
export * from "./data-service3.vue?vue&type=script&lang=js"
import style0 from "./data-service3.vue?vue&type=style&index=0&id=019dad30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019dad30",
  null
  
)

export default component.exports